import { FC, type JSX } from 'react'
import { useTranslation } from 'react-i18next'

import { CalendarIcon } from '@icons/CalendarIcon'
import { CirclePlusIcon } from '@icons/CirclePlusIcon'

import { FilterIcon } from '@ui/v2/Icons/FilterIcon'

import { useWindowResize } from '@utils/domUtils'

import { Button } from '@global/button/Button'
import IconButton from '@global/iconButton/IconButton'

import styles from './HeaderActions.module.scss'

interface HeaderActionsProps {
  onAddGroupClick?: () => void
  onFiltersClick?: () => void
  onCalendarClick?: () => void
}

export const HeaderActions: FC<HeaderActionsProps> = (props) => {
  const { t } = useTranslation()
  const isMobile = useWindowResize()

  type action = { icon: JSX.Element; label?: string }
  type actionKey = keyof HeaderActionsProps
  type actionsType = { [x in actionKey]: action }

  const actionDictionary: actionsType = {
    onAddGroupClick: {
      icon: <CirclePlusIcon />,
      label: t('IB.RebatesPage.GroupsPage.Create new group'),
    },
    onFiltersClick: { icon: <FilterIcon />, label: t('Filters') },
    onCalendarClick: { icon: <CalendarIcon /> },
  }

  const actions = Object.entries(actionDictionary).filter(([key]) => props[key as actionKey])

  const actionHandler = ([key, action]: [string, action]) =>
    isMobile ? (
      <IconButton.New appearance='secondary' size='S' onClick={props[key as actionKey]}>
        {action.icon}
      </IconButton.New>
    ) : (
      <Button.New
        renderLeftIcon={() => action.icon}
        appearance='secondary'
        size='S'
        onClick={props[key as actionKey]}
      >
        {action.label}
      </Button.New>
    )

  return <div className={styles.headerActions}>{actions.map(actionHandler)}</div>
}
